import { useQuery } from '@tanstack/react-query';
import { EmploymentStatus } from 'hooks/webapi/useClient';
import fetchData from 'utils/fetchData';
import useError from 'hooks/useError';
import useSmartlook from 'hooks/useSmartlook';

type ClientEmployer = {
  name: string;
  employmentStatus: EmploymentStatus;
  employmentDetail: string;
  naceCodes: string[];
};

export function useClientEmployerQuery() {
  const { showError } = useError();
  const { error } = useSmartlook();
  return useQuery<ClientEmployer>({
    queryKey: ['client', 'employer'],
    queryFn: async () => {
      try {
        const resp = await fetchData('/client/employer');

        return resp;
      } catch (e) {
        error('[useApplicationQuery][GET /client/employer]', e);
        showError();
        throw e;
      }
    },
  });
}
